import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Companhia } from '../modelo/Companhia';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompanhiaService {

  apiUrl: string = `${environment.backendUrl}/companhia`;

  constructor(private http: HttpClient) { }

  getCompanhias (){
    let searchParams = new HttpParams();

    return this.http.get<Companhia[]>(`${this.apiUrl}`,{ params: searchParams });
  }

}
